<template>
  <div>
    <LoadingAlert v-if="isFirstLoading" />
    <CCard v-else>
      <CCardHeader>
        {{ total_count }} 件の薬局会社を表示
        <div class="card-header-actions">
          <CLink class="card-header-action btn-setting text-primary" :to="{ name: '薬局会社新規作成' }">
            <CIcon name="cil-plus" />新規作成する
          </CLink>
        </div>
      </CCardHeader>
      <CCardBody>
        <CForm @submit.prevent="searchCompanies">
          <CInput v-model="query" placeholder="薬局会社名で検索">
            <template #append><CButton type="submit" color="info">検索</CButton></template>
          </CInput>
        </CForm>
        <CDataTable
          hover
          bordered
          fixed
          responsive
          :loading="isLoading"
          :items="companies"
          :fields="fields"
          :sorter="sorter"
          :sorter-value.sync="sorterValue"
        >
          <template #name="{item : company}">
            <td>
              <CLink :to="{ name: '薬局会社情報', params: { id: company.id } }">{{ company.name }}</CLink>
            </td>
          </template>
          <template #actions="{item : company}">
            <td>
              <CButton color="secondary" class="mr-1 mb-1" size="sm" :to="{ name: '薬局会社情報', params: { id: company.id } }">
                詳細
              </CButton>
              <CButton color="primary" class="mr-1 mb-1" size="sm" :to="{ name: '薬局会社編集', params: { id: company.id } }">
                編集
              </CButton>
            </td>
          </template>
        </CDataTable>
        <CPagination
          v-show="companies.length"
          align="center"
          responsive
          :active-page.sync="current_page"
          :pages="total_pages"
          :limit="10"
        />
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import LoadingAlert from "src/components/shared/LoadingAlert";

export default {
  name: "Companies",
  components: { LoadingAlert },
  data() {
    return {
      isFirstLoading: true,
      isLoading: false,
      query: null,
      companies: [],
      api_fields: ["id", "name", "pharmacies_count", "updated_at"],
      sorter: { external: true, resetable: false },
      sorterValue: { column: "updated_at", asc: false },
      current_page: 1,
      total_pages: 1,
      total_count: 0,
    };
  },
  computed: {
    fields() {
      return this.api_fields.concat({ key: "actions", sorter: false });
    },
    sort() {
      return this.sorterValue.asc ? this.sorterValue.column : `-${this.sorterValue.column}`;
    },
  },
  watch: {
    $route() {
      this.current_page = parseInt(this.$route.query.page) || 1;
    },
    current_page(page) {
      if (!this.$route.query.page || parseInt(this.$route.query.page) !== page) {
        this.$router.push({ query: { page: `${page}` } });
      }
      this.fetchCompanies();
    },
    sorterValue() {
      this.fetchCompanies();
    },
  },
  async created() {
    this.current_page = parseInt(this.$route.query.page) || 1;
    await this.fetchCompanies();
    this.isFirstLoading = false;
  },
  methods: {
    async fetchCompanies() {
      if (this.isLoading) return;

      this.isLoading = true;
      const fields = this.api_fields.join(",");
      const req_params = { page: this.current_page, query: this.query, sort: this.sort, fields: fields };
      const response = await this.$axios.get("/api/v2/core/admin/companies", { params: req_params });
      this.companies = response.data;
      this.current_page = Number(response.headers["x-current-page"]);
      this.total_pages = Number(response.headers["x-total-pages"]);
      this.total_count = Number(response.headers["x-total-count"]);
      this.isLoading = false;
    },
    searchCompanies() {
      this.current_page = 1;
      this.fetchCompanies();
    },
  },
};
</script>
